import Dropdown from '@Shared/Components/Dropdown';
import SvgImage from '@Customer/Src/Components/SvgImage';
import { useState } from 'react';

function HelpInfo({ info, icon = 'info', className = 'size-6' }) {
    const [isOpened, setIsOpened] = useState(false);
    return (
        <Dropdown
            isOpened={isOpened}
            setIsOpened={setIsOpened}
            width={200}
            btn={<SvgImage className={className} icon={icon} />}
        >
            <div
                className={`bg-surface-light relative flex max-h-[400px] w-[200px] rounded-md p-10 shadow-xl`}
            >
                {info}
            </div>
        </Dropdown>
    );
}

export default HelpInfo;
